/**
 * Статистика счёта в том виде, в каком она лежит в форме.
 * Комментарии приходят массивом только с загруженного счёта; на создании
 * комментарий один и лежит в поле `comment`.
 */
export type EuAccountStatLike = {
    id?: number | null;
    file?: number | null;
    comment?: string | null;
    services?: unknown[];
    comments?: unknown[];
};

/**
 * Есть ли в блоке статистики хоть что-то, что стоит отправлять на бэк.
 *
 * `setDefaultData` кладёт в форму пустую заготовку `{ id: 0, services: [], file: null }`
 * даже когда у счёта статистики нет вовсе. Если отправить её как есть, бэк заводит
 * по ней задачу на статистику, которую никто не создавал.
 *
 * Уже существующий блок (`id` больше нуля) отправляется всегда: его отсутствие
 * в запросе бэк понимает как удаление.
 */
export function isFilledEuAccountStat(stat: EuAccountStatLike): boolean {
    if (Number(stat.id ?? 0) > 0) {
        return true;
    }

    if (stat.file !== null && stat.file !== undefined) {
        return true;
    }

    if ((stat.services?.length ?? 0) > 0) {
        return true;
    }

    if ((stat.comment ?? '').trim().length > 0) {
        return true;
    }

    return (stat.comments?.length ?? 0) > 0;
}
